import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IMenu } from '../../../types/menu';

export enum EToggleMobileMenuActionType {
  Set = 'menu/toggleMobileMenu/set',
}

export type TToggleMobileMenu = ITypedReduxAction<EToggleMobileMenuActionType.Set, IMenu['isMobileMenuOpened']>;
